import { useState } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '~/eds/src/components/Button/Button';
import { Theme } from '~/eds/src/types/Theme';

import { CLMEvolutionFeedbackModal } from './CLMEvolutionFeedbackModal';
import { messages } from './messages';

interface CLMEvolutionFeedbackNavButtonProps {
  /** Matches the surrounding navbar theme so the label stays legible on both. */
  theme?: Theme;
}

export function CLMEvolutionFeedbackNavButton({
  theme,
}: CLMEvolutionFeedbackNavButtonProps) {
  const intl = useIntl();
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <Button
        icon="message"
        iconPosition="left"
        // `ghost` is the only subdued variant with a dark-theme style, and it
        // keeps the primary emphasis on the neighbouring opt-in CTA.
        level="ghost"
        size="s"
        text={intl.formatMessage(messages.open)}
        theme={theme}
        tooltip={intl.formatMessage(messages.tooltip)}
        onClick={() => setIsModalVisible(true)}
      />
      <CLMEvolutionFeedbackModal
        isVisible={isModalVisible}
        onHide={() => setIsModalVisible(false)}
      />
    </>
  );
}
